var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L30,0 L57,2 L77,4 L81,5 L109,11 L133,18 L141,20 L145,22 L170,32 L195,44 L199,45 L204,49 L224,61 L226,61 L230,65 L242,73 L259,86 L266,91 L271,96 L283,107 L304,128 L313,139 L321,149 L325,150 L323,152 L336,170 L341,178 L341,180 L343,181 L348,190 L351,190 L353,199 L357,207 L359,207 L360,213 L368,231 L369,236 L371,237 L373,244 L375,244 L375,252 L377,253 L378,261 L381,261 L380,265 L387,291 L391,310 L395,343 L396,359 L396,392 L394,418 L388,454 L381,482 L371,511 L367,522 L366,525 L364,528 L356,546 L351,554 L352,556 L349,556 L348,562 L345,565 L335,581 L323,598 L315,608 L306,619 L304,622 L302,622 L300,626 L285,642 L282,645 L280,645 L278,649 L276,651 L269,657 L258,666 L240,680 L225,690 L223,692 L215,696 L198,706 L182,714 L160,724 L132,734 L125,736 L124,740 L124,738 L115,739 L82,746 L51,750 L40,751 L-9,752 L-10,751 L-38,748 L-45,748 L-45,746 L-56,745 L-83,739 L-92,737 L-93,740 L-97,736 L-97,734 L-106,732 L-133,722 L-135,722 L-135,720 L-144,717 L-148,716 L-148,714 L-155,712 L-178,699 L-189,692 L-193,692 L-194,689 L-209,679 L-222,669 L-233,660 L-245,649 L-247,648 L-247,646 L-251,644 L-258,637 L-260,635 L-264,635 L-264,630 L-273,621 L-282,610 L-297,590 L-297,588 L-302,588 L-302,585 L-304,584 L-303,581 L-312,567 L-316,561 L-317,563 L-319,562 L-320,557 L-321,552 L-322,549 L-326,547 L-325,546 L-327,545 L-329,543 L-328,538 L-330,532 L-333,532 L-332,529 L-337,518 L-341,508 L-343,508 L-345,502 L-343,502 L-346,492 L-351,491 L-350,482 L-356,460 L-358,460 L-360,454 L-361,452 L-360,447 L-359,446 L-363,423 L-364,421 L-365,404 L-367,370 L-369,368 L-368,364 L-366,362 L-364,333 L-358,296 L-351,268 L-342,241 L-331,215 L-320,193 L-321,188 L-317,188 L-313,180 L-307,172 L-300,161 L-284,140 L-271,125 L-261,114 L-253,107 L-244,98 L-236,91 L-218,77 L-203,66 L-197,62 L-197,60 L-192,59 L-177,50 L-154,38 L-134,29 L-119,23 L-113,22 L-112,20 L-100,17 L-93,15 L-94,12 L-83,12 L-55,6 L-49,6 L-49,4 L-35,3 L-17,1 Z M-89,13 Z M-320,190 Z M349,191 L350,194 Z M-358,452 L-357,456 Z M-349,485 L-349,490 L-347,491 L-348,485 Z M-343,503 L-342,505 Z M-327,540 Z M-326,542 Z M-319,555 Z M-318,557 Z M-302,583 Z M-301,585 Z M-300,586 Z M-263,632 Z M-262,633 Z M-192,690 Z M-96,735 Z ",
    fill: "#1E6955",
    transform: "translate(497,116)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,4 L22,14 L26,16 L26,18 L31,19 L63,36 L92,49 L120,58 L138,62 L154,64 L183,64 L200,62 L225,56 L246,49 L263,42 L279,34 L303,22 L325,9 L338,0 L342,4 L352,22 L359,38 L366,59 L371,83 L372,91 L372,127 L370,143 L365,167 L359,185 L351,203 L342,219 L332,233 L321,246 L303,264 L286,277 L273,285 L250,297 L228,305 L208,310 L184,313 L153,313 L128,309 L107,303 L86,295 L63,283 L47,272 L36,263 L26,254 L16,244 L3,227 L-7,212 L-19,187 L-26,166 L-31,144 L-33,125 L-33,98 L-30,75 L-25,54 L-18,34 L-7,11 Z ",
    fill: "#1D6753",
    transform: "translate(343,430)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L26,4 L51,15 L87,30 L127,47 L181,70 L219,86 L264,105 L302,121 L308,125 L310,128 L310,137 L305,142 L287,150 L284,150 L284,261 L286,261 L291,270 L291,284 L288,290 L282,295 L278,297 L270,297 L263,294 L258,290 L254,282 L254,273 L257,266 L261,260 L262,159 L251,164 L219,177 L178,194 L141,209 L101,226 L62,242 L43,250 L18,260 L7,262 L-2,262 L-14,259 L-50,244 L-95,225 L-137,207 L-183,188 L-224,171 L-264,154 L-293,142 L-299,137 L-300,135 L-300,128 L-296,123 L-277,114 L-257,106 L-232,95 L-201,82 L-156,63 L-120,48 L-82,32 L-46,17 L-17,5 L-7,1 Z ",
    fill: "#142540",
    transform: "translate(507,176)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,1 L25,11 L77,37 L110,52 L137,63 L161,71 L178,75 L200,75 L224,69 L247,61 L271,51 L298,39 L327,25 L346,16 L365,6 L377,0 L382,1 L389,11 L402,34 L410,50 L418,68 L427,95 L432,116 L434,129 L435,141 L435,178 L433,196 L427,222 L417,252 L406,275 L395,293 L387,304 L378,315 L367,327 L356,338 L345,347 L332,357 L311,370 L290,381 L266,390 L245,396 L224,400 L205,402 L180,402 L150,399 L124,393 L104,386 L86,378 L65,367 L46,354 L32,343 L20,332 L4,316 L-7,302 L-21,281 L-33,258 L-41,237 L-47,216 L-51,198 L-53,183 L-53,136 L-51,119 L-46,95 L-40,75 L-32,55 L-24,38 L-12,17 L-2,2 Z M21,45 L12,60 L3,79 L-6,106 L-10,126 L-12,143 L-12,170 L-10,189 L-4,215 L4,237 L14,257 L24,272 L34,285 L45,297 L54,306 L68,317 L86,329 L109,341 L134,350 L159,356 L174,358 L205,358 L229,355 L252,349 L273,341 L298,328 L315,316 L328,305 L346,287 L359,270 L371,250 L378,235 L385,215 L390,194 L392,183 L393,172 L393,136 L389,112 L383,91 L375,71 L366,54 L360,45 L351,50 L341,57 L320,69 L288,85 L264,95 L243,102 L215,108 L204,109 L175,109 L154,106 L134,101 L111,93 L84,81 L57,67 L50,63 L47,63 L47,61 L35,54 L22,45 Z ",
    fill: "#14243F",
    transform: "translate(322,385)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,4 L22,14 L26,16 L24,21 L15,38 L7,59 L2,77 L-1,96 L-1,127 L3,151 L9,171 L17,190 L27,207 L37,220 L48,232 L60,243 L78,256 L103,269 L124,276 L142,280 L150,281 L189,281 L212,277 L236,269 L252,261 L265,253 L277,244 L289,233 L300,222 L313,204 L322,188 L329,172 L335,153 L338,136 L339,126 L339,96 L335,72 L326,45 L317,26 L312,17 L329,6 L338,0 L342,4 L352,22 L359,38 L366,59 L371,83 L372,91 L372,127 L370,143 L365,167 L359,185 L351,203 L342,219 L332,233 L321,246 L303,264 L286,277 L273,285 L250,297 L228,305 L208,310 L184,313 L153,313 L128,309 L107,303 L86,295 L63,283 L47,272 L36,263 L26,254 L16,244 L3,227 L-7,212 L-19,187 L-26,166 L-31,144 L-33,125 L-33,98 L-30,75 L-25,54 L-18,34 L-7,11 Z ",
    fill: "#DEEFE6",
    transform: "translate(343,430)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17,0 L27,3 L36,9 L44,18 L48,28 L49,32 L49,42 L46,53 L45,57 L72,84 L84,79 L102,79 L111,82 L120,89 L126,97 L130,107 L130,121 L127,130 L121,139 L113,146 L103,150 L86,150 L76,146 L68,140 L62,132 L58,121 L58,109 L60,101 L32,73 L27,74 L16,78 L3,78 L-7,75 L-13,72 L-41,100 L-39,110 L-39,119 L-43,132 L-49,140 L-58,147 L-67,150 L-83,150 L-93,146 L-99,142 L-106,134 L-111,122 L-111,108 L-107,97 L-99,87 L-89,81 L-83,79 L-66,79 L-56,83 L-53,84 L-26,57 L-30,46 L-30,29 L-26,19 L-18,9 L-7,2 Z ",
    fill: "#FDFDFD",
    transform: "translate(503,510)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,1 L33,14 L37,15 L42,19 L62,31 L64,31 L68,35 L80,43 L97,56 L104,61 L109,66 L121,77 L142,98 L151,109 L159,119 L157,121 L144,105 L133,93 L129,88 L124,83 L111,71 L97,59 L81,47 L62,34 L46,24 L35,18 L1,2 Z ",
    fill: "#134335",
    transform: "translate(659,146)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,5 L14,18 L18,24 L18,26 L20,27 L25,36 L28,36 L30,45 L34,53 L36,53 L37,59 L45,77 L46,82 L48,83 L50,90 L52,90 L52,98 L54,99 L55,107 L58,107 L57,111 L64,137 L65,142 L65,150 L63,147 L58,125 L53,107 L43,79 L32,55 L22,36 L9,15 L0,2 Z M26,37 L27,40 Z ",
    fill: "#134335",
    transform: "translate(820,270)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,5 L15,18 L27,32 L39,45 L54,60 L65,69 L77,79 L95,92 L112,103 L109,104 L104,102 L102,102 L101,99 L86,89 L73,79 L62,70 L50,59 L48,58 L48,56 L44,54 L37,47 L35,45 L31,45 L31,40 L22,31 L13,20 L0,3 Z M32,42 Z M33,43 Z M103,100 Z ",
    fill: "#144435",
    transform: "translate(202,706)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L-14,13 L-28,24 L-42,36 L-58,51 L-65,58 L-72,66 L-84,80 L-97,98 L-107,113 L-108,110 L-101,99 L-87,80 L-76,67 L-67,57 L-60,49 L-52,42 L-43,33 L-35,26 L-17,12 L-2,1 Z ",
    fill: "#124033",
    transform: "translate(296,181)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L0,2 L-2,6 L-4,8 L-11,14 L-22,23 L-40,37 L-55,47 L-57,49 L-65,53 L-82,63 L-98,71 L-102,73 L-106,72 L-80,59 L-58,46 L-39,33 L-25,22 L-12,11 L-10,11 L-9,8 L-1,1 Z ",
    fill: "#144235",
    transform: "translate(777,759)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,101 L0,102 L0,3 L-10,6 L-9,4 Z ",
    fill: "#217A58",
    transform: "translate(767,335)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L2,5 L4,2 L8,12 L19,40 L27,57 L32,67 L29,67 L28,64 L24,62 L25,61 L23,60 L21,58 L22,53 L20,47 L17,47 L18,44 L13,33 L9,23 L7,23 L5,17 L7,17 L4,7 L-1,6 Z M7,18 L8,20 Z M23,55 Z M24,57 Z ",
    fill: "#1A5140",
    transform: "translate(147,601)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,63 L-1,61 L-3,27 L-5,25 L-4,21 L-2,19 L-1,1 Z ",
    fill: "#0F3B2F",
    transform: "translate(133,459)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,2 L31,13 L63,24 L70,26 L70,27 L62,27 L61,30 L57,26 L57,24 L48,22 L21,12 L19,12 L19,10 L10,7 L6,6 L6,4 L1,2 Z M58,25 Z ",
    fill: "#144537",
    transform: "translate(343,826)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L-7,6 L-27,15 L-50,27 L-64,36 L-66,35 L-62,31 L-39,18 L-17,7 Z ",
    fill: "#134335",
    transform: "translate(368,143)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,4 L2,37 L0,63 L-2,72 L-3,72 L-3,60 L-1,41 Z ",
    fill: "#164536",
    transform: "translate(891,471)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L-3,4 L-4,8 L-4,6 L-13,7 L-46,14 L-52,15 L-63,15 L-63,14 L-36,9 L-14,4 Z ",
    fill: "#154637",
    transform: "translate(625,848)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L17,0 L65,1 L64,3 L15,4 L14,3 L3,2 Z ",
    fill: "#144335",
    transform: "translate(473,864)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,4 L-8,25 L-13,33 L-12,35 L-15,35 L-16,41 L-19,44 L-26,55 L-29,55 L-21,42 L-9,20 Z ",
    fill: "#144235",
    transform: "translate(861,637)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L3,5 L3,21 L0,29 L1,33 L25,57 L26,56 L31,56 L26,60 L19,54 L-3,32 L0,22 L1,17 L1,7 Z ",
    fill: "#082818",
    transform: "translate(550,535)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L30,0 L46,1 L50,3 L17,3 L-1,2 Z ",
    fill: "#1A5140",
    transform: "translate(497,116)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L0,11 L-12,47 L-16,55 L-18,54 L-11,36 L-6,21 Z ",
    fill: "#113F32",
    transform: "translate(880,580)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,4 L11,15 L19,25 L28,35 L35,42 L48,52 L45,53 L32,42 L18,28 L8,15 L0,2 Z ",
    fill: "#F1F6F4",
    transform: "translate(362,626)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,4 L6,24 L8,33 L8,38 L6,37 L4,29 L2,29 L0,23 L-1,21 L0,16 L1,15 L0,10 Z M2,21 L3,25 Z ",
    fill: "#1A4D3E",
    transform: "translate(137,547)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L0,12 L-2,21 L-6,49 L-7,49 L-7,34 L-2,5 Z ",
    fill: "#113D31",
    transform: "translate(141,407)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L0,10 L-4,24 L-5,33 L-7,33 L-8,38 L-9,38 L-9,31 L-1,3 Z ",
    fill: "#124134",
    transform: "translate(151,368)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L-11,25 L-17,37 L-18,33 L-8,13 L-9,8 L-5,8 Z M-8,10 Z ",
    fill: "#123C31",
    transform: "translate(185,296)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,1 L19,4 L23,6 L39,12 L39,14 L30,12 L20,8 L1,2 Z ",
    fill: "#154638",
    transform: "translate(619,132)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,5 L15,18 L24,29 L24,31 L22,31 L13,20 L0,3 Z ",
    fill: "#133E31",
    transform: "translate(202,706)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L0,25 L-1,39 L-2,39 L-2,1 Z ",
    fill: "#D5E5DF",
    transform: "translate(714,521)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,5 L14,18 L18,24 L18,26 L20,27 L19,31 L7,12 L0,2 Z ",
    fill: "#124335",
    transform: "translate(820,270)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L14,0 L30,1 L34,3 L36,5 L23,4 L4,2 Z ",
    fill: "#134335",
    transform: "translate(548,119)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,3 L12,20 L16,30 L15,33 L14,29 L12,29 L9,20 L0,2 Z ",
    fill: "#113428",
    transform: "translate(655,448)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,0 L3,2 L-21,10 L-24,10 L-24,8 L-15,5 L-13,5 L-12,3 Z ",
    fill: "#144436",
    transform: "translate(397,133)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L4,16 L4,34 L3,34 L0,9 Z ",
    fill: "#10382C",
    transform: "translate(887,433)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,3 L14,21 L17,26 L14,26 L3,8 L0,3 Z ",
    fill: "#123D30",
    transform: "translate(181,673)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L2,10 L2,23 L-1,33 L-4,36 L-1,26 L0,21 L0,12 L-2,2 Z ",
    fill: "#042212",
    transform: "translate(463,608)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L6,2 L24,12 L27,15 L22,14 L2,3 Z ",
    fill: "#134133",
    transform: "translate(315,811)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,3 L10,22 L10,25 L6,25 L7,22 L2,11 L-1,1 Z ",
    fill: "#144435",
    transform: "translate(158,623)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L-6,15 L-8,15 L-9,8 L-5,8 Z M-8,10 Z ",
    fill: "#184D3E",
    transform: "translate(185,296)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L0,4 L-8,14 L-12,18 L-14,17 L-6,8 Z ",
    fill: "#123C30",
    transform: "translate(811,721)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,31 L0,31 L-1,9 L-2,7 L-2,1 Z ",
    fill: "#D3E4DC",
    transform: "translate(312,527)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L-6,5 L-17,10 L-21,11 L-23,10 L-13,5 Z ",
    fill: "#0F1037",
    transform: "translate(471,189)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,0 L6,1 L6,3 L2,4 L-9,4 L-8,2 Z ",
    fill: "#174E3E",
    transform: "translate(427,125)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,3 L-9,13 L-11,15 L-14,14 Z ",
    fill: "#154135",
    transform: "translate(793,743)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L8,0 L14,1 L13,3 L5,5 L0,5 L0,2 Z M5,1 Z ",
    fill: "#195140",
    transform: "translate(403,128)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-19,13 L-21,14 L-23,12 Z ",
    fill: "#23855D",
    transform: "translate(635,753)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L3,15 L3,23 L1,22 L-1,14 Z ",
    fill: "#123C2F",
    transform: "translate(134,523)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,3 L-8,15 L-11,15 Z ",
    fill: "#123C30",
    transform: "translate(824,704)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,5 L5,7 L8,7 L8,13 L4,11 L0,4 Z M6,8 L7,11 Z ",
    fill: "#1A5242",
    transform: "translate(840,299)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,21 L0,21 L-1,8 L-3,6 L-2,2 Z ",
    fill: "#36856B",
    transform: "translate(131,478)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,4 L8,11 L7,14 L1,4 L-3,4 L-2,1 Z ",
    fill: "#ECF1F0",
    transform: "translate(681,430)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L2,2 L-10,9 L-13,8 Z ",
    fill: "#113C2F",
    transform: "translate(717,806)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,1 L9,7 L6,7 L6,5 L1,5 L1,2 L-1,1 Z M2,2 Z M3,3 Z ",
    fill: "#1D5544",
    transform: "translate(194,699)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,4 L3,14 L1,13 L-1,2 Z ",
    fill: "#123F31",
    transform: "translate(142,571)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L3,6 L1,6 L0,11 L-1,11 L-1,4 Z ",
    fill: "#185443",
    transform: "translate(143,395)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,1 L14,3 L5,3 L0,1 Z ",
    fill: "#123F31",
    transform: "translate(430,857)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,4 L5,9 L2,9 L1,6 L-3,4 L-1,3 Z ",
    fill: "#174A3C",
    transform: "translate(174,659)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L-1,4 L-10,5 L-9,3 Z ",
    fill: "#22815B",
    transform: "translate(597,771)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,5 L8,9 L7,12 L0,2 Z ",
    fill: "#0F382C",
    transform: "translate(820,270)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L-2,5 L-10,7 L-7,4 Z ",
    fill: "#22755E",
    transform: "translate(329,163)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,3 L-7,9 L-9,8 Z ",
    fill: "#217F5B",
    transform: "translate(681,719)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,3 L4,6 L1,9 L-1,8 Z ",
    fill: "#0F3C2B",
    transform: "translate(474,561)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L-1,2 L-1,4 L-8,5 L-5,2 Z ",
    fill: "#0F1239",
    transform: "translate(325,250)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L-1,4 L-8,5 L-5,2 Z ",
    fill: "#0F1439",
    transform: "translate(380,227)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,3 L-3,9 L-5,9 L-3,4 Z ",
    fill: "#124034",
    transform: "translate(831,694)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,3 L3,5 L-1,2 Z ",
    fill: "#D6E5DE",
    transform: "translate(433,693)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,8 L-1,8 L-2,2 Z ",
    fill: "#0D432E",
    transform: "translate(463,608)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0 L3,8 L0,6 Z ",
    fill: "#CFE2D9",
    transform: "translate(682,556)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,3 L-2,3 L-1,9 L-5,4 L-2,1 Z ",
    fill: "#EDF3F0",
    transform: "translate(660,444)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L7,6 L4,7 L0,3 Z ",
    fill: "#174B3D",
    transform: "translate(772,216)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,3 L-7,9 L-6,5 Z ",
    fill: "#20735D",
    transform: "translate(263,208)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,2 L7,6 L3,5 L0,2 Z ",
    fill: "#144739",
    transform: "translate(794,239)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,7 L-2,6 L-2,2 L0,2 Z M-1,3 Z ",
    fill: "#307860",
    transform: "translate(130,512)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,5 L-2,4 L-2,2 L0,2 Z ",
    fill: "#307961",
    transform: "translate(130,464)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0 L1,4 L-1,3 Z ",
    fill: "#2C745D",
    transform: "translate(284,184)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,0 L4,2 Z ",
    fill: "#2E765F",
    transform: "translate(440,862)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,0 L4,2 L0,2 Z ",
    fill: "#2E755E",
    transform: "translate(406,854)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,1 L2,2 Z ",
    fill: "#2A725C",
    transform: "translate(660,144)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,3 L-1,1 Z ",
    fill: "#2D735D",
    transform: "translate(273,784)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L-1,4 Z ",
    fill: "#2C755E",
    transform: "translate(257,771)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L3,3 Z ",
    fill: "#2C715B",
    transform: "translate(218,733)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0 L2,2 L-1,1 Z ",
    fill: "#2C735C",
    transform: "translate(196,272)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,3 L-2,1 Z ",
    fill: "#2A735C",
    transform: "translate(758,200)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L0,2 Z ",
    fill: "#29735C",
    transform: "translate(339,153)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L1,3 Z ",
    fill: "#2D755E",
    transform: "translate(359,837)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,4 Z ",
    fill: "#2C745D",
    transform: "translate(312,812)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,3 Z ",
    fill: "#2D745B",
    transform: "translate(278,789)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,4 Z ",
    fill: "#2C735D",
    transform: "translate(200,709)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L2,3 L0,3 Z ",
    fill: "#2F775F",
    transform: "translate(136,573)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,5 L0,5 Z ",
    fill: "#2D745D",
    transform: "translate(136,557)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,0 L1,5 L0,5 Z ",
    fill: "#2C755D",
    transform: "translate(136,416)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,4 Z ",
    fill: "#2B745E",
    transform: "translate(169,320)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,4 Z ",
    fill: "#2D745D",
    transform: "translate(193,272)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L0,2 Z ",
    fill: "#2B735D",
    transform: "translate(311,168)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,0 L3,2 L0,1 Z ",
    fill: "#28705A",
    transform: "translate(709,168)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 L2,2 Z ",
    fill: "#2B725B",
    transform: "translate(682,154)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L5,0 L5,1 L0,1 Z ",
    fill: "#2C735D",
    transform: "translate(613,128)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 Z ",
    fill: "#2F745E",
    transform: "translate(612,855)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,3 L0,3 Z ",
    fill: "#2C715C",
    transform: "translate(192,696)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,1 Z ",
    fill: "#2B725B",
    transform: "translate(160,640)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,4 Z ",
    fill: "#2F7760",
    transform: "translate(131,524)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,3 Z ",
    fill: "#307760",
    transform: "translate(128,457)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,1 Z ",
    fill: "#2F7760",
    transform: "translate(129,456)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,1 Z ",
    fill: "#2A735B",
    transform: "translate(186,288)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L1,3 Z ",
    fill: "#29715B",
    transform: "translate(830,280)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,3 Z ",
    fill: "#29735D",
    transform: "translate(208,257)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-2,1 Z ",
    fill: "#29735C",
    transform: "translate(814,256)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,1 Z ",
    fill: "#28705B",
    transform: "translate(805,248)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,2 Z ",
    fill: "#2D755D",
    transform: "translate(304,168)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L-1,1 Z ",
    fill: "#2B745D",
    transform: "translate(321,162)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,2 Z ",
    fill: "#29725B",
    transform: "translate(326,160)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 L0,1 Z ",
    fill: "#2C755F",
    transform: "translate(581,120)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 Z ",
    fill: "#2C765E",
    transform: "translate(441,120)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 Z ",
    fill: "#30765F",
    transform: "translate(535,115)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L4,1 Z ",
    fill: "#2E755E",
    transform: "translate(513,114)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2F745C",
    transform: "translate(480,867)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2F725C",
    transform: "translate(573,863)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2D755E",
    transform: "translate(447,863)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2E755D",
    transform: "translate(581,862)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2F755E",
    transform: "translate(425,859)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2D745D",
    transform: "translate(659,839)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2D735C",
    transform: "translate(677,831)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,1 Z ",
    fill: "#2C745D",
    transform: "translate(695,822)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2E735C",
    transform: "translate(299,806)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,2 Z ",
    fill: "#2D715B",
    transform: "translate(296,801)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,2 Z ",
    fill: "#2C725B",
    transform: "translate(264,777)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,2 Z ",
    fill: "#2A725B",
    transform: "translate(240,756)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,1 Z ",
    fill: "#2B715C",
    transform: "translate(798,742)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,1 Z ",
    fill: "#2C745E",
    transform: "translate(225,740)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,2 Z ",
    fill: "#2D735C",
    transform: "translate(192,702)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2E725C",
    transform: "translate(184,685)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30765F",
    transform: "translate(144,605)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,1 Z ",
    fill: "#2E755D",
    transform: "translate(146,599)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755E",
    transform: "translate(887,561)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32775E",
    transform: "translate(133,541)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31755D",
    transform: "translate(891,535)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(132,530)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2E7760",
    transform: "translate(128,448)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30765F",
    transform: "translate(132,442)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A715C",
    transform: "translate(879,384)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#28715A",
    transform: "translate(209,256)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#28725B",
    transform: "translate(216,248)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,2 Z ",
    fill: "#28725A",
    transform: "translate(224,240)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#29715B",
    transform: "translate(790,232)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725D",
    transform: "translate(232,225)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2B705B",
    transform: "translate(782,224)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#28715B",
    transform: "translate(247,216)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2A725B",
    transform: "translate(275,192)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,2 Z ",
    fill: "#29735C",
    transform: "translate(726,176)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 L0,2 Z ",
    fill: "#29745D",
    transform: "translate(323,160)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2A755D",
    transform: "translate(336,152)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,0 L1,2 Z ",
    fill: "#2B745D",
    transform: "translate(355,145)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2A735C",
    transform: "translate(360,144)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,2 Z ",
    fill: "#2C755D",
    transform: "translate(645,136)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2A755D",
    transform: "translate(379,137)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L1,2 L-1,1 Z ",
    fill: "#2C755E",
    transform: "translate(619,128)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L3,1 Z ",
    fill: "#2E765E",
    transform: "translate(547,116)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,2 L0,2 Z ",
    fill: "#2F755F",
    transform: "translate(532,114)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2E735E",
    transform: "translate(524,868)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#30745D",
    transform: "translate(493,868)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#31765E",
    transform: "translate(542,867)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755E",
    transform: "translate(594,859)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#30755D",
    transform: "translate(596,859)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2F765E",
    transform: "translate(411,855)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2F705C",
    transform: "translate(638,847)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B725B",
    transform: "translate(384,847)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2D745C",
    transform: "translate(365,839)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2F755D",
    transform: "translate(666,836)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#30745D",
    transform: "translate(357,836)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735D",
    transform: "translate(345,830)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C725D",
    transform: "translate(338,827)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B755D",
    transform: "translate(707,815)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C745D",
    transform: "translate(314,813)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C735D",
    transform: "translate(289,799)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C725B",
    transform: "translate(291,798)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C745D",
    transform: "translate(267,782)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B765C",
    transform: "translate(764,774)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2A735C",
    transform: "translate(252,767)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2A715C",
    transform: "translate(240,759)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2D755E",
    transform: "translate(227,742)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725C",
    transform: "translate(216,728)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725E",
    transform: "translate(209,719)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A745D",
    transform: "translate(202,710)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(168,661)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755F",
    transform: "translate(854,659)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A725B",
    transform: "translate(163,643)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745D",
    transform: "translate(155,625)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755E",
    transform: "translate(145,596)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32775F",
    transform: "translate(883,580)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F725D",
    transform: "translate(140,577)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7860",
    transform: "translate(884,574)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317860",
    transform: "translate(128,536)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317761",
    transform: "translate(892,526)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307760",
    transform: "translate(894,491)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F795F",
    transform: "translate(128,490)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E775D",
    transform: "translate(129,487)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307760",
    transform: "translate(894,479)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7A61",
    transform: "translate(129,476)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307961",
    transform: "translate(128,474)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715B",
    transform: "translate(887,417)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7961",
    transform: "translate(137,412)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735F",
    transform: "translate(885,409)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7760",
    transform: "translate(138,409)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755F",
    transform: "translate(870,358)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725D",
    transform: "translate(156,350)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735C",
    transform: "translate(862,338)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(861,336)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725B",
    transform: "translate(180,300)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C735E",
    transform: "translate(192,280)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735C",
    transform: "translate(823,267)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735B",
    transform: "translate(821,267)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C725C",
    transform: "translate(822,264)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2A6D5B",
    transform: "translate(798,240)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A715C",
    transform: "translate(238,224)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2D725D",
    transform: "translate(735,185)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B715B",
    transform: "translate(733,184)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2A735D",
    transform: "translate(726,179)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C755E",
    transform: "translate(724,178)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#29735B",
    transform: "translate(297,176)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B745C",
    transform: "translate(306,171)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735D",
    transform: "translate(309,169)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B6F59",
    transform: "translate(678,152)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2B735C",
    transform: "translate(343,152)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C725B",
    transform: "translate(665,146)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2C735C",
    transform: "translate(641,136)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2F755C",
    transform: "translate(627,132)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2D755E",
    transform: "translate(622,130)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C765D",
    transform: "translate(401,128)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2F7660",
    transform: "translate(592,122)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#2E775E",
    transform: "translate(438,120)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L2,1 Z ",
    fill: "#30765E",
    transform: "translate(464,117)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#6D8479",
    transform: "translate(308,934)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#868E87",
    transform: "translate(108,902)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E775F",
    transform: "translate(488,869)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32745C",
    transform: "translate(530,868)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775F",
    transform: "translate(490,868)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755B",
    transform: "translate(538,867)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307761",
    transform: "translate(468,866)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765E",
    transform: "translate(438,863)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765E",
    transform: "translate(435,863)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32745F",
    transform: "translate(430,863)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317760",
    transform: "translate(596,862)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775E",
    transform: "translate(579,862)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775E",
    transform: "translate(436,862)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765E",
    transform: "translate(585,861)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(435,861)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7A5F",
    transform: "translate(433,861)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30745E",
    transform: "translate(591,860)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755D",
    transform: "translate(434,860)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775F",
    transform: "translate(432,860)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F785E",
    transform: "translate(599,858)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(402,855)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(617,854)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30735E",
    transform: "translate(623,852)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30745F",
    transform: "translate(398,851)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765E",
    transform: "translate(645,847)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735D",
    transform: "translate(383,846)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775E",
    transform: "translate(645,845)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765D",
    transform: "translate(379,845)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775F",
    transform: "translate(376,845)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765F",
    transform: "translate(377,844)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765D",
    transform: "translate(376,843)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755D",
    transform: "translate(372,842)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755D",
    transform: "translate(655,841)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31765F",
    transform: "translate(358,839)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307660",
    transform: "translate(352,839)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715B",
    transform: "translate(663,838)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C715A",
    transform: "translate(363,838)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745F",
    transform: "translate(355,838)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307560",
    transform: "translate(352,837)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755F",
    transform: "translate(671,834)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745D",
    transform: "translate(352,833)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A725C",
    transform: "translate(347,831)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7660",
    transform: "translate(685,830)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D715D",
    transform: "translate(338,829)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745D",
    transform: "translate(683,828)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(686,827)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715C",
    transform: "translate(337,826)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C755F",
    transform: "translate(336,825)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A745D",
    transform: "translate(329,822)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7360",
    transform: "translate(697,821)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745F",
    transform: "translate(699,820)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735A",
    transform: "translate(326,820)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E735C",
    transform: "translate(321,819)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745D",
    transform: "translate(318,815)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A725C",
    transform: "translate(709,814)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735C",
    transform: "translate(316,814)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(723,806)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755C",
    transform: "translate(297,805)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F735C",
    transform: "translate(300,804)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735B",
    transform: "translate(298,803)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(733,799)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(293,799)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A715A",
    transform: "translate(290,797)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30745C",
    transform: "translate(288,796)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745F",
    transform: "translate(746,790)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C6F59",
    transform: "translate(280,790)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C755E",
    transform: "translate(747,788)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(750,787)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(266,783)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745C",
    transform: "translate(755,782)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725B",
    transform: "translate(270,782)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755E",
    transform: "translate(759,781)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755E",
    transform: "translate(756,781)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725A",
    transform: "translate(269,781)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765C",
    transform: "translate(266,779)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A785E",
    transform: "translate(763,775)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765F",
    transform: "translate(259,773)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735D",
    transform: "translate(256,770)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735C",
    transform: "translate(251,766)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735B",
    transform: "translate(250,765)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745D",
    transform: "translate(248,765)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B745F",
    transform: "translate(249,764)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F715A",
    transform: "translate(248,763)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755D",
    transform: "translate(781,759)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A715A",
    transform: "translate(244,759)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B7159",
    transform: "translate(243,758)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B705A",
    transform: "translate(242,757)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735C",
    transform: "translate(789,751)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725C",
    transform: "translate(232,751)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A705B",
    transform: "translate(790,750)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F735D",
    transform: "translate(232,747)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#29725B",
    transform: "translate(229,743)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A705A",
    transform: "translate(799,740)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B785E",
    transform: "translate(803,735)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765F",
    transform: "translate(804,734)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(218,731)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755E",
    transform: "translate(208,727)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(212,726)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E725C",
    transform: "translate(213,725)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745D",
    transform: "translate(208,725)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755D",
    transform: "translate(814,723)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735E",
    transform: "translate(211,722)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745B",
    transform: "translate(815,721)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715C",
    transform: "translate(210,721)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755F",
    transform: "translate(208,718)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755E",
    transform: "translate(820,714)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745D",
    transform: "translate(821,713)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E735B",
    transform: "translate(204,713)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30745D",
    transform: "translate(822,712)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B7059",
    transform: "translate(200,707)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735D",
    transform: "translate(828,703)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735E",
    transform: "translate(830,700)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755D",
    transform: "translate(189,692)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C715C",
    transform: "translate(836,691)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E735D",
    transform: "translate(188,690)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755F",
    transform: "translate(184,689)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E6F5C",
    transform: "translate(839,687)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E725C",
    transform: "translate(186,687)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D705B",
    transform: "translate(184,683)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F725D",
    transform: "translate(181,679)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755D",
    transform: "translate(176,679)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32755E",
    transform: "translate(849,669)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#337760",
    transform: "translate(851,664)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B745E",
    transform: "translate(169,663)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D7460",
    transform: "translate(169,660)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32745D",
    transform: "translate(165,649)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D7460",
    transform: "translate(860,646)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D775F",
    transform: "translate(160,646)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(861,645)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(161,645)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7560",
    transform: "translate(863,642)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735E",
    transform: "translate(160,642)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#337761",
    transform: "translate(870,631)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(157,629)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307660",
    transform: "translate(869,626)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755E",
    transform: "translate(153,625)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7460",
    transform: "translate(870,623)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D7660",
    transform: "translate(871,621)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#33745F",
    transform: "translate(873,613)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32745D",
    transform: "translate(149,609)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(876,606)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765D",
    transform: "translate(144,601)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(878,599)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D7660",
    transform: "translate(879,598)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#347861",
    transform: "translate(887,581)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31765C",
    transform: "translate(141,581)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31755E",
    transform: "translate(884,577)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317962",
    transform: "translate(885,573)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307761",
    transform: "translate(136,571)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7661",
    transform: "translate(886,567)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#35775F",
    transform: "translate(890,544)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31745D",
    transform: "translate(890,542)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#33765F",
    transform: "translate(891,541)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317960",
    transform: "translate(132,535)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317661",
    transform: "translate(894,534)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#337962",
    transform: "translate(128,533)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317962",
    transform: "translate(130,531)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#327961",
    transform: "translate(128,531)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317560",
    transform: "translate(892,530)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735E",
    transform: "translate(131,522)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317661",
    transform: "translate(893,521)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317B62",
    transform: "translate(130,520)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30745F",
    transform: "translate(893,513)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30785F",
    transform: "translate(893,511)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(130,510)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7760",
    transform: "translate(894,499)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7760",
    transform: "translate(128,498)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307661",
    transform: "translate(894,494)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7A5E",
    transform: "translate(129,493)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775F",
    transform: "translate(894,483)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7A60",
    transform: "translate(130,475)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7B60",
    transform: "translate(130,472)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307B60",
    transform: "translate(128,472)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7660",
    transform: "translate(893,470)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307B62",
    transform: "translate(128,470)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7960",
    transform: "translate(129,469)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317862",
    transform: "translate(894,467)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307560",
    transform: "translate(893,465)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765E",
    transform: "translate(893,463)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317861",
    transform: "translate(129,461)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307660",
    transform: "translate(131,455)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(131,453)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307760",
    transform: "translate(892,451)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(132,446)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#327962",
    transform: "translate(893,441)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317862",
    transform: "translate(891,440)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#33745D",
    transform: "translate(133,437)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725B",
    transform: "translate(887,421)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D775F",
    transform: "translate(137,415)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(886,414)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#317660",
    transform: "translate(885,407)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30735D",
    transform: "translate(883,402)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775F",
    transform: "translate(884,400)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30765C",
    transform: "translate(882,395)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31755B",
    transform: "translate(881,392)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(144,387)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B755E",
    transform: "translate(144,385)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D7860",
    transform: "translate(878,383)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C7761",
    transform: "translate(145,381)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B765E",
    transform: "translate(144,380)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F785F",
    transform: "translate(146,379)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715C",
    transform: "translate(147,376)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F735D",
    transform: "translate(148,372)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745F",
    transform: "translate(145,372)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755B",
    transform: "translate(149,370)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E735A",
    transform: "translate(874,369)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755F",
    transform: "translate(144,369)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735D",
    transform: "translate(145,368)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#33745E",
    transform: "translate(148,366)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E715F",
    transform: "translate(152,360)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(153,357)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C7760",
    transform: "translate(871,355)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765D",
    transform: "translate(152,355)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725D",
    transform: "translate(154,354)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725F",
    transform: "translate(869,353)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(154,352)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#808E86",
    transform: "translate(1004,350)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#3F7966",
    transform: "translate(884,350)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735E",
    transform: "translate(863,340)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#296F59",
    transform: "translate(160,340)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755E",
    transform: "translate(858,329)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765F",
    transform: "translate(857,328)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745B",
    transform: "translate(161,328)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715C",
    transform: "translate(854,320)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F735D",
    transform: "translate(853,319)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725B",
    transform: "translate(852,318)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725D",
    transform: "translate(850,313)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E715A",
    transform: "translate(173,313)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E725C",
    transform: "translate(849,312)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735B",
    transform: "translate(174,312)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F735F",
    transform: "translate(846,303)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745D",
    transform: "translate(179,302)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755D",
    transform: "translate(842,299)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C715B",
    transform: "translate(841,298)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(840,297)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725B",
    transform: "translate(182,297)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A745D",
    transform: "translate(185,292)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B755D",
    transform: "translate(184,291)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735E",
    transform: "translate(837,289)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745D",
    transform: "translate(835,288)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C755E",
    transform: "translate(184,288)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745C",
    transform: "translate(834,283)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715D",
    transform: "translate(192,282)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745C",
    transform: "translate(828,278)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755D",
    transform: "translate(195,277)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7560",
    transform: "translate(192,277)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C755C",
    transform: "translate(826,275)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735E",
    transform: "translate(830,273)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735C",
    transform: "translate(823,271)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#26725B",
    transform: "translate(200,271)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725B",
    transform: "translate(201,269)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735D",
    transform: "translate(202,267)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(822,266)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#27705B",
    transform: "translate(203,266)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A755B",
    transform: "translate(818,264)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#29735D",
    transform: "translate(203,264)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#286E5B",
    transform: "translate(807,250)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#297159",
    transform: "translate(216,250)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30735E",
    transform: "translate(813,249)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(801,243)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745C",
    transform: "translate(796,238)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735E",
    transform: "translate(232,232)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745E",
    transform: "translate(232,229)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735D",
    transform: "translate(236,225)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A715B",
    transform: "translate(240,224)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725C",
    transform: "translate(780,222)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C725C",
    transform: "translate(244,221)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(778,219)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E735D",
    transform: "translate(240,219)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725C",
    transform: "translate(246,217)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B6D59",
    transform: "translate(774,216)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C745B",
    transform: "translate(240,216)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#29705A",
    transform: "translate(767,210)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735A",
    transform: "translate(255,210)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#286E5B",
    transform: "translate(766,209)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B725B",
    transform: "translate(258,208)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755D",
    transform: "translate(764,206)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735B",
    transform: "translate(264,203)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#29725B",
    transform: "translate(755,200)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735D",
    transform: "translate(267,200)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755F",
    transform: "translate(268,198)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725A",
    transform: "translate(749,195)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#29745C",
    transform: "translate(274,195)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#286F59",
    transform: "translate(275,194)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B735D",
    transform: "translate(273,194)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E715E",
    transform: "translate(745,192)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30785E",
    transform: "translate(740,189)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765C",
    transform: "translate(281,189)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755C",
    transform: "translate(738,187)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A755F",
    transform: "translate(282,187)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735C",
    transform: "translate(740,186)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735C",
    transform: "translate(737,186)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765E",
    transform: "translate(739,185)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(743,184)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7460",
    transform: "translate(737,184)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B715B",
    transform: "translate(288,184)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765D",
    transform: "translate(280,184)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31765E",
    transform: "translate(730,179)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A745B",
    transform: "translate(296,179)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#28725C",
    transform: "translate(297,178)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A735A",
    transform: "translate(721,176)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F775D",
    transform: "translate(716,173)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755E",
    transform: "translate(714,171)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745E",
    transform: "translate(308,171)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745D",
    transform: "translate(304,171)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B765C",
    transform: "translate(308,168)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(700,163)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D725B",
    transform: "translate(698,162)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765C",
    transform: "translate(699,161)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745C",
    transform: "translate(697,161)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E755E",
    transform: "translate(700,160)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765D",
    transform: "translate(320,160)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D715C",
    transform: "translate(687,156)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D745C",
    transform: "translate(335,156)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C765D",
    transform: "translate(336,155)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745D",
    transform: "translate(681,152)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D765E",
    transform: "translate(671,149)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B745C",
    transform: "translate(352,147)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C755D",
    transform: "translate(358,144)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F715B",
    transform: "translate(655,142)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#537D6D",
    transform: "translate(260,142)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C715D",
    transform: "translate(370,140)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30755C",
    transform: "translate(648,139)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A725C",
    transform: "translate(377,138)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E775F",
    transform: "translate(372,138)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735B",
    transform: "translate(643,137)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F755E",
    transform: "translate(371,137)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D755F",
    transform: "translate(368,137)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B755E",
    transform: "translate(647,136)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B755D",
    transform: "translate(382,136)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765D",
    transform: "translate(388,134)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C765E",
    transform: "translate(393,132)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#32765C",
    transform: "translate(626,131)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2C735F",
    transform: "translate(397,131)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E785E",
    transform: "translate(400,130)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E775E",
    transform: "translate(392,129)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2D735E",
    transform: "translate(599,124)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775E",
    transform: "translate(594,123)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E775F",
    transform: "translate(432,122)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B765E",
    transform: "translate(437,121)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2A7660",
    transform: "translate(435,121)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E765F",
    transform: "translate(424,121)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2B765A",
    transform: "translate(446,120)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#307761",
    transform: "translate(551,116)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(543,116)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30725C",
    transform: "translate(478,116)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F765F",
    transform: "translate(473,116)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#30785F",
    transform: "translate(471,116)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#31775F",
    transform: "translate(480,115)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F745E",
    transform: "translate(518,114)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7762",
    transform: "translate(509,114)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E7660",
    transform: "translate(503,114)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#327760",
    transform: "translate(552,113)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2E745E",
    transform: "translate(519,113)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7660",
    transform: "translate(474,113)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7860",
    transform: "translate(534,112)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#2F7760",
    transform: "translate(486,112)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M0,0 Z ",
    fill: "#70877D",
    transform: "translate(420,6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.7492d08ddb46d22bdbe4ea0aec18c427.svg";
export { ForwardRef as ReactComponent };